import { ref } from 'vue';
import get from 'lodash/get';

export function useExpansion(props) {
  const expandedRows = ref(props.rowKey ? {} : []);
  const expandedSubRows = ref(props.subRowKey ? {} : []);
  const rowCanExpand = (rowData) => {
    return props.canExpand && (rowData.useCustomSubRow || (rowData.subRows && rowData.subRows.length > 0));
  };
  const expandRow = (event) => {
    expandedRows.value[get(event.data, props.rowKey)] = true;
  };
  const expandAllRows = () => {
    const rowKeysToExpand = {};
    props.data.forEach((row) => {
      if (rowCanExpand(row)) {
        rowKeysToExpand[get(row, props.rowKey)] = true;
      }
    });
    expandedRows.value = rowKeysToExpand;
  };

  const collapseRow = (event) => {
    const value = get(event.data, props.rowKey);
    if (expandedRows.value[value]) {
      delete expandedRows.value[value];
    }
  };
  const collapseAllRows = () => {
    expandedRows.value = {};
  };
  const isRowExpanded = (rowData) => {
    if (typeof expandedRows.value === 'object') {
      return expandedRows.value[get(rowData, props.rowKey)];
    }

    return expandedRows.value.includes(rowData);
  };

  const toggleRowExpansion = (event) => {
    if (!isRowExpanded(event.data)) {
      expandRow(event);
    } else {
      collapseRow(event);
    }
  };

  return {
    // Reactive properties
    expandedRows,
    expandedSubRows,

    // Methods
    rowCanExpand,
    expandRow,
    collapseRow,
    expandAllRows,
    collapseAllRows,
    isRowExpanded,
    toggleRowExpansion,
  };
}
